/* Vulkanus · v3 · 24.10.2026 (DEV 71, Entwurf)
   Header: Aufklappfelder, mobile Schublade, Sprache/Land, Suche mit festem Index.
   Außerdem: sanfte Einblendung für [data-v3-in]. Ohne JavaScript bleibt alles lesbar. */
(function () {
  'use strict';

  /* ---------- Hilfen ---------- */
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/ß/g, 'ss').replace(/ae/g, 'a').replace(/oe/g, 'o').replace(/ue/g, 'u');
  }
  function tokens(q) { return norm(q).split(/[^a-z0-9]+/).filter(Boolean); }

  var root = $('[data-v3h]');

  /* ---------- Einblendung ---------- */
  (function reveal() {
    var els = $$('[data-v3-in]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
    setTimeout(function () { els.forEach(function (e) { e.classList.add('is-in'); }); }, 4500);
  })();

  if (!root) return;

  /* ---------- Höhen für das Theme (Sticky-Leisten brauchen --header-height) ---------- */
  var bar = $('#v3h', root);
  function setHeights() {
    if (!bar) return;
    var b = Math.round(bar.getBoundingClientRect().bottom);
    root.style.setProperty('--v3-hdr-bottom', b + 'px');
    var usp = $('.v3h-usp', root);
    if (usp) document.body.style.setProperty('--v3-usp-h', usp.offsetHeight + 'px');
    document.body.style.setProperty('--header-height', bar.offsetHeight + 'px');
    var grp = document.getElementById('header-group');
    if (grp) document.body.style.setProperty('--header-group-height', grp.offsetHeight + 'px');
  }
  var tick = false;
  function onScroll() { if (tick) return; tick = true; requestAnimationFrame(function () { tick = false; setHeights(); }); }
  window.addEventListener('scroll', onScroll, { passive: true });
  /* Das Theme scrollt in .page-wrapper, dessen scroll-Ereignisse nicht bis window steigen */
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('resize', setHeights);
  window.addEventListener('load', setHeights);
  setHeights();

  /* ---------- Aufklappfelder (Desktop: Hover/Fokus per CSS; Touch: erster Tipp öffnet) ---------- */
  var items = $$('.v3h__item.has-panel', root);
  function closeItems(except) { items.forEach(function (it) { if (it !== except) { it.classList.remove('is-open'); var a = $('.v3h__link', it); if (a) a.setAttribute('aria-expanded', 'false'); } }); }
  items.forEach(function (it) {
    var link = $('.v3h__link', it);
    it.addEventListener('mouseenter', function () { setHeights(); if (link) link.setAttribute('aria-expanded', 'true'); });
    it.addEventListener('mouseleave', function () { if (link && !it.classList.contains('is-open')) link.setAttribute('aria-expanded', 'false'); });
    link.addEventListener('focus', function () { setHeights(); link.setAttribute('aria-expanded', 'true'); });
    link.addEventListener('click', function (e) {
      if (window.matchMedia('(hover: none)').matches && !it.classList.contains('is-open')) {
        e.preventDefault(); closeItems(it); it.classList.add('is-open'); setHeights(); link.setAttribute('aria-expanded', 'true');
      }
    });
  });
  document.addEventListener('click', function (e) { if (!e.target.closest('.v3h__item')) closeItems(null); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeItems(null); items.forEach(function (it) { var a = $('.v3h__link', it); if (a && it.contains(document.activeElement)) a.blur(); }); }
  });

  /* ---------- Mobile Schublade ---------- */
  var drawer = $('[data-v3d]', root);
  var lastFocus = null;
  function openDrawer() {
    if (!drawer) return; lastFocus = document.activeElement;
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('v3-lock');
    $$('[data-v3-open]', root).forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var c = $('.v3d__close', drawer); if (c) setTimeout(function () { c.focus(); }, 60);
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('v3-lock');
    $$('[data-v3-open]', root).forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  $$('[data-v3-open]', root).forEach(function (b) { b.addEventListener('click', openDrawer); });
  $$('[data-v3-close]', root).forEach(function (b) { b.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer(); });
  window.addEventListener('resize', function () { if (window.innerWidth >= 990 && drawer && drawer.classList.contains('is-open')) closeDrawer(); });
  $$('[data-v3d-acc]', root).forEach(function (acc) {
    var btn = $('button', acc);
    btn.addEventListener('click', function () {
      var open = !acc.classList.contains('is-open');
      acc.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------- Sprache / Land ---------- */
  $$('[data-v3loc]', root).forEach(function (loc) {
    var btn = $('[data-v3loc-btn]', loc), pop = $('[data-v3loc-pop]', loc);
    btn.addEventListener('click', function (e) {
      e.stopPropagation(); var open = pop.hidden;
      pop.hidden = !open; btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', function (e) { if (!loc.contains(e.target)) { pop.hidden = true; btn.setAttribute('aria-expanded', 'false'); } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { pop.hidden = true; btn.setAttribute('aria-expanded', 'false'); } });
  });

  /* ---------- Suche ---------- */
  var indexEl = $('[data-v3-index]', root), IDX = null;
  try { IDX = JSON.parse(indexEl.textContent); } catch (e) { IDX = { items: [] }; }
  IDX.items.forEach(function (it) { it._h = norm(it.title + ' ' + (it.kw || '')); it._t = norm(it.title); it._tw = it._t.split(/[^a-z0-9]+/).filter(Boolean); });
  var searchUrl = root.getAttribute('data-search-url') || '/search';
  var L = {
    no: root.getAttribute('data-no-label'), help: root.getAttribute('data-no-help'),
    all: root.getAttribute('data-all-label'), models: root.getAttribute('data-models-label'), pages: root.getAttribute('data-pages-label')
  };
  var ICON_PAGE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 3.5h7l4 4V20a.5.5 0 0 1-.5.5h-10A.5.5 0 0 1 7 20z"/><path d="M14 3.5V8h4M9.5 12.5h5M9.5 15.5h5"/></svg>';

  function score(it, toks) {
    var s = 0, i, tk, hit;
    for (i = 0; i < toks.length; i++) {
      tk = toks[i]; hit = 0;
      if (it._tw.some(function (w) { return w.indexOf(tk) === 0; })) hit = 3;
      else if ((' ' + it._h).indexOf(' ' + tk) > -1) hit = 2;
      else if (tk.length >= 3 && it._h.indexOf(tk) > -1) hit = 1;
      if (!hit) return 0;
      s += hit;
    }
    if (it._t === toks.join(' ')) s += 10;
    if (it.t === 'product') s += 0.5;
    return s;
  }
  function find(q) {
    var toks = tokens(q); if (!toks.length) return [];
    return IDX.items.map(function (it) { return { it: it, s: score(it, toks) }; })
      .filter(function (r) { return r.s > 0; })
      .sort(function (a, b) { return b.s - a.s; })
      .map(function (r) { return r.it; });
  }
  function resHtml(it, n, pid) {
    var id = pid + '-r' + n;
    if (it.t === 'product') {
      return '<a class="v3s__res" role="option" id="' + id + '" href="' + esc(it.url) + '" aria-selected="false">' +
        '<span class="v3s__res-img">' + (it.img ? '<img src="' + esc(it.img) + '" alt="" width="46" height="46" loading="lazy">' : '') + '</span>' +
        '<span class="v3s__res-n">' + esc(it.title) + '</span><span class="v3s__res-p">' + esc(it.price) + '</span></a>';
    }
    return '<a class="v3s__res v3s__res--page" role="option" id="' + id + '" href="' + esc(it.url) + '" aria-selected="false">' +
      '<span class="v3s__res-img">' + ICON_PAGE + '</span><span class="v3s__res-n">' + esc(it.title) + '</span></a>';
  }

  $$('[data-v3s]', document).forEach(function (form) {
    var input = $('input[type=search]', form), pop = $('.v3s__pop', form), pid = pop.id;
    var shown = [], sel = -1, timer = null, ctl = null;

    function open() { pop.hidden = false; input.setAttribute('aria-expanded', 'true'); }
    function close() { pop.hidden = true; input.setAttribute('aria-expanded', 'false'); sel = -1; input.removeAttribute('aria-activedescendant'); }
    function select(n) {
      var els = $$('.v3s__res', pop); if (!els.length) return;
      sel = (n + els.length) % els.length;
      els.forEach(function (e, i) { e.setAttribute('aria-selected', i === sel ? 'true' : 'false'); });
      input.setAttribute('aria-activedescendant', els[sel].id); els[sel].scrollIntoView({ block: 'nearest' });
    }
    function render(q, list, extra) {
      shown = list; sel = -1; var html = '', n = 0;
      var prods = list.filter(function (x) { return x.t === 'product'; });
      var pgs = list.filter(function (x) { return x.t !== 'product'; });
      if (!q) {
        prods = IDX.items.filter(function (x) { return x.t === 'product'; });
        pgs = IDX.items.filter(function (x) { return x.t === 'page' && /(\/pages\/(wissen|messer|contact|haendler))$/.test(x.url); });
      }
      if (prods.length) { html += '<p class="v3s__h">' + esc(L.models) + '</p><div class="v3s__list">'; prods.slice(0, 6).forEach(function (x) { html += resHtml(x, n++, pid); }); html += '</div>'; }
      if (pgs.length) { html += '<p class="v3s__h">' + esc(L.pages) + '</p><div class="v3s__list">'; pgs.slice(0, 5).forEach(function (x) { html += resHtml(x, n++, pid); }); html += '</div>'; }
      if (q && !n) {
        html = '<p class="v3s__none">' + esc(L.no) + ' „' + esc(q) + '“. ' + esc(L.help) + '</p>';
      }
      if (q) html += '<a class="v3s__all" href="' + esc(searchUrl) + '?q=' + encodeURIComponent(q) + '&amp;options%5Bprefix%5D=last"><span>' + esc(L.all) + ' „' + esc(q) + '“</span><span aria-hidden="true">→</span></a>';
      pop.innerHTML = html; open();
    }
    function remote(q) {
      if (ctl) ctl.abort();
      if (!window.AbortController) return;
      ctl = new AbortController();
      fetch(searchUrl + '/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,page&resources[limit]=4', { signal: ctl.signal, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (!j || input.value.trim() !== q) return;
          var r = (j.resources && j.resources.results) || {}, add = [];
          (r.products || []).forEach(function (p) {
            if (shown.some(function (x) { return x.url === p.url.split('?')[0]; })) return;
            add.push({ t: 'product', title: p.title, url: p.url.split('?')[0], price: p.price ? (p.price + ' €').replace('.', ',') : '', img: p.image || '' });
          });
          (r.pages || []).forEach(function (p) {
            if (shown.some(function (x) { return x.url === p.url.split('?')[0]; })) return;
            add.push({ t: 'page', title: p.title, url: p.url.split('?')[0] });
          });
          if (add.length) render(q, shown.concat(add));
        }).catch(function () {});
    }
    function update() {
      var q = input.value.trim();
      var res = q ? find(q) : [];
      render(q, res);
      if (q && res.length < 2) { clearTimeout(timer); timer = setTimeout(function () { remote(q); }, 220); }
    }

    input.addEventListener('focus', function () { update(); });
    input.addEventListener('input', update);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (pop.hidden) update(); select(sel + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); select(sel - 1); }
      else if (e.key === 'Escape') { close(); input.blur(); }
    });
    form.addEventListener('submit', function (e) {
      var q = input.value.trim();
      var els = $$('.v3s__res', pop);
      if (sel > -1 && els[sel]) { e.preventDefault(); window.location.href = els[sel].getAttribute('href'); return; }
      if (!q) { e.preventDefault(); return; }
      var res = find(q), toks = tokens(q), prods = res.filter(function (x) { return x.t === 'product'; });
      /* eindeutig: genau ein Modell passt auf alle Wörter, oder der Titel stimmt genau überein */
      if (res.length && (norm(res[0].title).replace(/[^a-z0-9]+/g, ' ').trim() === toks.join(' ') || (prods.length === 1 && res.filter(function (x) { return x.t === 'page'; }).length === 0))) {
        e.preventDefault(); window.location.href = res[0].url;
      }
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
  });
})();
